// Recovered compiled webpack factory 95704. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  var n, a;
  e.exports =
    (null == (n = r.g.process) ? void 0 : n.env) &&
    "object" == typeof (null == (a = r.g.process) ? void 0 : a.env)
      ? r.g.process
      : r(53965);
}
